import { fontSizeBase } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { blue } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const dynamicRange = `
	.dynamic-range {
		display: flex;
		flex-direction: column;
		margin-bottom: 40px;
		&--text {
			font-size: ${fontSizeBase};
			width: 100%;
		}

		.miles {
			font-weight: 500;
			color: ${blue};
		}
	}
`;
